import { Button } from 'primereact/button';
import classes from './MSSalesPlanNavigator.module.scss';

const MSSalesPlanNavigator = ({
  msPlanClick,
  salesPlanClick,
  currentScreen,
}: {
  msPlanClick: () => void;
  salesPlanClick: () => void;
  currentScreen: 'salesPlan' | 'msPlan';
}) => {
  return (
    <div className={classes.MSSalesPlanNavigatorContainer}>
      <Button
        className={
          currentScreen === 'msPlan' ? classes.navigationButtonActive : classes.navigationButton
        }
        onClick={msPlanClick}
      >
        MS Plan
      </Button>
      <Button
        className={
          currentScreen === 'salesPlan' ? classes.navigationButtonActive : classes.navigationButton
        }
        onClick={salesPlanClick}
      >
        Sales Plan
      </Button>
    </div>
  );
};

export default MSSalesPlanNavigator;
